<template>
  <router-link :to="location">
    {{text}}
  </router-link>
</template>

<script>
export default {
  name: 'RushRaceLink',

  props: {
    rushRaceId: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'race'
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.rushRaceId;

      const loc = {
        name: 'rush_race',
        params: {
          rushId: id.rushId,
          raceId: id.raceId,
        }
      };

      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const raceIdStr = this.rushRaceId.raceId.toString();

      if(label.length > 0) {
        return label + ' ' + raceIdStr;
      } else {
        return raceIdStr;
      }
    },
  }
};
</script>
